import { defaultConfig } from './config'

export function formatCurrency(value, currency = defaultConfig.currency) {
    const formats = {
        USD: () => {
            return `${new Intl.NumberFormat('lt-LT', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `${value}`
}

export function unbindOriginalSearch(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
        var newElement = el.cloneNode(true);
        el.parentNode.replaceChild(newElement, el);
    })
}

function detectWebsite() {
    if (window.Shopify.currency.active === 'USD') {
        return 'usa'
    }
}

export const currency = {
    usa: '$',
}[detectWebsite()]

export function cleanValue(str) {
    return str.replaceAll('["', "").replaceAll('"]', "").replaceAll('","', ", ")
}

export function addTrailingZeros(num) {
    const numericAmount = parseFloat(num);
    if (isNaN(numericAmount)) {
        return
    }
    return `${numericAmount.toFixed(2)}`;
}

export function checkReviews() {
    return new Promise((resolve, reject) => {
        function check() {
            if (typeof okeWidgetApi?.initAllWidgets === "function") {
                okeWidgetApi.initAllWidgets();
                resolve();
            } else {
                setTimeout(check, 1000);
            }
        }
        check();
    });
}


export function removeEmptyElements() {
    const reviewDivs = document.querySelectorAll('.nosto-reviews .okeReviews');

    reviewDivs.forEach(div => {
        if (div.children.length == 1) {
            div.parentElement.parentElement.remove()
        }
    });
};

export function handleize(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}

export function setFullHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function getHandle(url){
    return url.substring(url.lastIndexOf('/') + 1);
}

// export function getSizeFromPageUrlParam() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const pageParam = urlParams.get('page');
//     return (pageParam && !isNaN(pageParam))
//         ?   Math.round(pageParam)
//         :   undefined
// }

export function getPaginationValues() {
    const urlParams = new URLSearchParams(window.location.search);
    
    const pageParam = urlParams.get('page');
    const productsSizeParam = urlParams.get('products.size');
    
    const productsPerPage = productsSizeParam ? parseInt(productsSizeParam) : defaultConfig?.serpSize;
    
    if (pageParam && !isNaN(pageParam) && productsPerPage) {
        const page = parseInt(pageParam);

        if (page > 0) {
            const size = productsPerPage;
            const from = (page - 1) * productsPerPage;

            return { size, from };
        }
    }

    return undefined;
}

export function normalize(string) {
    return string.toLowerCase().trim();
}